import { render } from "./IconBusinessCard.vue?vue&type=template&id=14f533a4"
const script = {}

import exportComponent from "/home/balluff-sales-applinksderisario/sales-app.balluff.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__